import React, { useState } from "react"

import btnVectorImage from "../../images/luca-pay/btn-vector.svg"
import btnVectorArrowImage from "../../images/luca-pay/btn-vector-arrow.svg"
import footerCurveImage from "../../images/new-pricing/footer-curve.svg"
import sendImage from "../../images/new-pricing/send.svg"
import mapPinImage from "../../images/new-pricing/map-pin.svg"
import backToTopImage from "../../images/new-pricing/back-to-top.png"
import Modali, { useModali } from "../modal"
import ReactGA from "react-ga"
import Axios from "axios"
import {getMailChimpEndPoint} from "../../utils";
import lucaplusFreeBgImage from "../../images/lucaplus-free-bg.png"
import lucaplusFreeBgMobImage from "../../images/lucaplus-free-bg-mob.png"
import lucaplusLogo from "../../images/logo-v2.svg"
import btnLeftVectorImage from "../../images/btn-left-vector.svg"
import btnRightVectorImage from "../../images/btn-right-vector.svg"
import { Link } from "gatsby"

export default function Footer({solo, page, freeImg, toggleExistingOrgModal}) {
  const [contactModal, toggleContactModal] = useModali()
  const [emailValue, setEmailValue] = useState()
  const [submitting, setSubmitting] = useState(false)
  const [errorMsg, setErrorMsg] = useState("")
  const isPartner = page === "Partner Page"
  const isQBO = page === "QBO page"
  const requestDemoClick = () => {
    toggleContactModal();
    ReactGA.event({
      category: `${page}_Footer_Request A Demo`,
      action: `${page}_Footer_Request A Demo`
    });
  }

  const labelClick = (label) => {
    ReactGA.event({
      category: `${page}_Footer_Solo Plan ${label}`,
      action: `${page}_Footer_Solo Plan ${label}`
    });
  }

  const sendBtnClick = () => {
    const mailChimpEndPoint = getMailChimpEndPoint();
    if(!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(emailValue)) {
      setErrorMsg("Invalid email address")
      return
    }
    setSubmitting(true)
    Axios.post(mailChimpEndPoint, {
      email: emailValue,
      audienceId: "8424685982",
      mergeFields: {
        EMAIL: emailValue
      },
    })
      .then(function(response) {
        setSubmitting(false)
        console.log(response)
        if(response.data.success){
          ReactGA.event({
            category: `${page}_Footer_Email Sign Up`,
            action: `${page}_Footer_Email Sign Up`
          });
        } else {
          setErrorMsg(response.data.message || "Something went wrong, Please Try Again!");
        }
      })
      .catch(function(error) {
        setErrorMsg("Something went wrong, Please Try Again!");
        setSubmitting(false)
      })
  }

  const socialIconClick = (iconName) => {
    ReactGA.event({
      category: `${page}_Footer_${iconName}`,
      action: `${page}_Footer_${iconName}`
    });
  }

  const handleOnChange = (e) => {
    setErrorMsg('')
    setEmailValue(e.target.value)
  }

  const backToTopClick = () => {
    try {
      document.querySelector('.top').scrollIntoView({
        behavior: 'smooth',
        top: 0,
        left: 0,
      });
    } catch (error) {
      window.scrollTo(0, 0);
    }
  }


  return (
    <section className={`${isPartner ||isQBO || !freeImg ? 'bg': ''} new-footer-1 relative`}>
      {(!isPartner && !isQBO && freeImg) && <div className="background" />}
      {(!isPartner && !isQBO && freeImg) &&
      <div className="container mx-auto">
        <div className="free relative">
          <img src={lucaplusFreeBgImage} className="img w-full sm:block hidden" />
          <img src={lucaplusFreeBgMobImage} className="img sm:hidden" />
          <div className="header">Try <img src={lucaplusLogo} className="mx-2" /> for free now</div>
          <Link  to={`/sign-up?plan=combined&lucapay=true&fromHomePage=true`}>
          <div className="flex items-center justify-content-center absolute btn">
            <img src={btnLeftVectorImage} />
            <div className="get-started-btn">Get Started</div>
            <img src={btnRightVectorImage} />
          </div>
          </Link>
        </div>
      </div>}
      <div className="absolute hidden sm:block">
        <img src={footerCurveImage} />
      </div>
      <div className='flex justify-between items-center footer-content container flex-col sm:flex-row'>
        <div className='relative sm:mb-12 mb-8 sm:mb-0'>
          <div className=' btn '>
            <div className='text-16 font-bold mb-5'>
              Need a demo from us?
            </div>
            <a
              className="req-demo-btn sm:ml-6 cursor-pointer focus:outline-none flex justify-center items-center relative"
              onClick={requestDemoClick}
            >
              Request a demo
              <img src={btnVectorImage} className="arrow" alt="right arrow"/>
              <img src={btnVectorArrowImage} className="absolute vector-arrow" alt="right arrow"/>
            </a>
          </div>
        </div>

        <div className='border-bottom w-full sm:hidden block' />

        <div className="sm:-mt-2 mx-0 sm:ml-0 ml-5 sm:mx-10 mt-4 footer-links flex flex-row links items-start justify-between">
        <ul className="sm:items-start flex flex-col items-start justify-between ">
          <div
            className="no-underline text-brand font-bold text-16 py-1 px-2 mr-20"
          >
            Company
          </div>
          <li className="mt-3 capitalize text-15">
            <a
              onClick={() => labelClick('About Us')}
              href="/about/"
              className="no-underline hover:text-gray-26    py-1 px-2"
            >
              About us
            </a>
          </li>
          <li className="mt-4 capitalize text-15">
            <a
              onClick={() => labelClick('FAQ')}
              href="https://go.luca.plus/faqs"
              className="no-underline hover:text-gray-26    py-1 px-2"
            >
              FAQ
            </a>
          </li>
          <li className="mt-4 capitalize text-15">
            <a
              onClick={() => labelClick('Blog')}
              href="https://blog.lucaplus.com/"
              className="no-underline hover:text-gray-26 rounded   py-1 px-2"
            >
              Blog
            </a>
          </li>
          <li className="mt-4 capitalize text-15">
            <a
              onClick={() => labelClick('Contact Us')}
              href={'/contact'}
              className="no-underline hover:text-gray-26 rounded   py-1 px-2"
            >
              Contact us
            </a>
          </li>
        </ul>
        <ul className="sm:items-start flex flex-col items-start justify-between ">
          <div
            className="no-underline text-brand font-bold text-16 py-1 px-2"
          >
            Browse
          </div>
          <li className="mt-3 capitalize text-15">
            <a
              onClick={() => labelClick('Support')}
              href="https://lucaplus.zendesk.com/hc/en-us"
              className={`no-underline hover:text-gray-26 rounded px-2`}
            >
              Support
            </a>
          </li>
          <li className="mt-4 min-w text-15 text-15 whitespace-no-wrap">
            <a
              onClick={() => labelClick('Term of Service')}
              href="https://docs.lucaplus.com/terms-of-service"
              className="no-underline hover:text-gray-26 rounded   py-1 px-2"
            >
              Terms of Service
            </a>
          </li>
          <li className=" mt-4 min-w capitalize text-15">
            <a
              onClick={() => labelClick('Privacy')}
              href="https://docs.lucaplus.com/security-compliance-privacy"
              className="no-underline hover:text-gray-26 rounded   py-1 px-2"
            >
              Privacy
            </a>
          </li>
        </ul>
      </div>

        <div>
          <div className="mt-8 sm:block flex justify-content-center">
            <span className='sm:mt-0 sm:mx-0 mx-5'>
            {errorMsg && (
              <div className=" text-red-600 mt-1 text-left max-w-xs">{errorMsg}</div>
            )}
            <div className="no-underline text-brand font-bold text-16 py-1 mb-2 sm:mr-20 text-left">
              Stay current with LUCA Plus news
            </div>
            <div className='flex sm:pb-0 pb-5'>
              <input
                type="text"
                placeholder="Your email"
                value={emailValue}
                onChange={handleOnChange}
              />
              <button className="btn-left bg-mind rounded leading-7 text-white capitalize px-5 hover:bg-mint2 ml-3" disabled={submitting} onClick={sendBtnClick}>
               <img src={sendImage}/>
              </button>
            </div>
            </span>
          </div>
          <div className='border-bottom w-full sm:hidden block' />
          <span className="sm:mx-0 mx-5">
            <ul className="flex flex-row items-center text-left sm:justify-start justify-center mt-3 social-icon">
              <li onClick={() => socialIconClick('LinkedIn')}>
                <a
                  href="https://www.linkedin.com/company/LucaPlus/"
                  target="_blank"
                  className="no-underline inline-flex items-center pr-1 py-2 text-gray-26 hover:text-brand rounded font-bold text-xl"
                >
                  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M29.5745 14.8205C29.5745 6.66635 22.9643 0.0458984 14.8102 0.0458984C6.65611 0.0458984 0.0458984 6.66635 0.0458984 14.8205C0.0458984 22.9746 6.65611 29.595 14.8102 29.595C22.9643 29.595 29.5745 22.9746 29.5745 14.8205ZM10.6553 21.285L10.6553 16.3631C10.6553 14.6991 10.6553 13.0584 10.7022 11.4178C10.7022 11.2303 10.6788 11.16 10.468 11.16L7.44664 11.16C7.25927 11.16 7.21242 11.2303 7.21242 11.3944L7.21242 21.3319C7.21242 21.5194 7.25927 21.5662 7.44664 21.5662C7.77453 21.5662 8.10243 21.5636 8.43033 21.561C9.08612 21.5558 9.74192 21.5506 10.3977 21.5662C10.6085 21.5662 10.6553 21.4959 10.6553 21.285ZM22.8338 21.5657C21.8501 21.5423 20.8899 21.5423 19.9062 21.5657C19.6954 21.5657 19.6485 21.5189 19.6485 21.3079L19.6485 16.0814C19.6485 15.6829 19.6251 15.2845 19.508 14.9095C19.1567 13.6907 17.7514 13.2454 16.7443 14.0657C16.2056 14.4876 15.9948 15.0735 15.9948 15.7767L15.9948 20.6985C15.9948 20.768 15.9923 20.8374 15.9897 20.9077L15.9897 20.9078C15.9845 21.0509 15.9791 21.1976 15.9948 21.3548C16.0273 21.6147 15.6292 21.5657 15.3673 21.5657L12.7627 21.5657C12.5753 21.5657 12.5285 21.5189 12.5285 21.3314C12.5519 19.8548 12.5519 18.3782 12.5519 16.8782C12.5519 15.0501 12.5519 13.222 12.5285 11.4173C12.5285 11.2064 12.5753 11.1595 12.7627 11.1595L15.7606 11.1595C15.948 11.1595 15.9948 11.2064 15.9948 11.3939L15.9948 12.4296C15.9948 12.4885 16.066 12.5179 16.1076 12.4763C16.1105 12.4734 16.1131 12.4702 16.1154 12.4669C17.0287 11.1351 18.3155 10.7613 19.8359 10.9954C21.5925 11.2767 22.7167 12.4954 22.9978 14.3704C23.0681 14.8157 23.0915 15.261 23.0915 15.7064L23.0915 21.3079C23.0915 21.4954 23.0446 21.5657 22.8338 21.5657ZM8.52312 9.72973C9.62392 9.91723 10.5842 9.37816 10.8184 8.44066C11.1229 7.19848 10.2563 6.14379 8.9447 6.16723C8.07812 6.14379 7.3989 6.56566 7.11784 7.26879C6.69626 8.39379 7.35206 9.54223 8.52312 9.72973Z" fill="#9AA1B7"/>
                  </svg>
                </a>
              </li>
              <li onClick={() => socialIconClick('Instagram')}>
                <a
                  href="https://www.instagram.com/LucaPlusAU/"
                  target="_blank"
                  className="no-underline inline-flex items-center  px-1 py-2 text-gray-26 hover:text-brand  rounded   font-bold md:ml-2 text-xl"
                >
                  <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.0205078 15.2827C0.0205078 6.99902 6.73682 0.282715 15.0205 0.282715C23.3042 0.282715 30.0205 6.99902 30.0205 15.2827C30.0205 23.5664 23.3042 30.2827 15.0205 30.2827C6.73682 30.2827 0.0205078 23.5664 0.0205078 15.2827ZM15.0205 7.28467C12.8489 7.28467 12.5742 7.29565 11.7209 7.33228C10.8677 7.37256 10.2891 7.50806 9.78003 7.70581C9.24536 7.90723 8.76196 8.22217 8.36279 8.62866C7.9563 9.02783 7.64136 9.51123 7.43994 10.0459C7.24219 10.5549 7.10669 11.1372 7.06641 11.9868C7.02979 12.8401 7.0188 13.1111 7.0188 15.2864C7.0188 17.458 7.02979 17.729 7.06641 18.5823C7.10669 19.4355 7.24219 20.0142 7.43994 20.5232C7.64502 21.0505 7.91968 21.4937 8.36279 21.9404C8.80591 22.3872 9.25269 22.6582 9.78003 22.8633C10.2891 23.061 10.8713 23.1965 11.7209 23.2368C12.5742 23.2771 12.8452 23.2844 15.0205 23.2844C17.1921 23.2844 17.4631 23.2734 18.3201 23.2368C19.1697 23.1965 19.752 23.061 20.261 22.8633C20.7957 22.6619 21.2791 22.3469 21.6782 21.9404C22.125 21.4973 22.396 21.0505 22.6011 20.5232C22.7988 20.0142 22.9343 19.4319 22.9746 18.5823C23.0112 17.729 23.0222 17.458 23.0222 15.2827C23.0222 13.1111 23.0112 12.8364 22.9746 11.9832C22.9343 11.1335 22.7988 10.5513 22.6011 10.0422C22.3997 9.50757 22.0847 9.02417 21.6782 8.625C21.2791 8.21851 20.7957 7.90356 20.261 7.70215C19.752 7.50439 19.1697 7.3689 18.3164 7.32861C17.4631 7.29199 17.1921 7.28467 15.0205 7.28467ZM19.2905 10.0532C19.8215 10.0532 20.25 10.4817 20.25 11.0127C20.25 11.5437 19.8215 11.9722 19.2905 11.9722C18.7595 11.9722 18.3311 11.5437 18.3311 11.0127C18.3311 10.4817 18.7595 10.0532 19.2905 10.0532ZM15.0205 11.1738C17.291 11.1738 19.1294 13.0122 19.1294 15.2827C19.1294 17.5532 17.291 19.3916 15.0205 19.3916C12.75 19.3916 10.9116 17.5532 10.9116 15.2827C10.9116 13.0159 12.75 11.1738 15.0205 11.1738ZM15.0205 12.6167C13.5483 12.6167 12.3545 13.8105 12.3545 15.2827C12.3545 16.7549 13.5483 17.9487 15.0205 17.9487C16.4927 17.9487 17.6865 16.7549 17.6865 15.2827C17.6902 13.8105 16.4927 12.6167 15.0205 12.6167Z" fill="#9AA1B7"/>
                  </svg>
                </a>
              </li>
              <li onClick={() => socialIconClick('Twitter')}>
                <a
                  href="https://twitter.com/LucaPlusAU"
                  target="_blank"
                  className="no-underline inline-flex items-center  px-1 py-2 text-gray-26 hover:text-brand  rounded  font-bold md:ml-2 text-xl"
                >
                  <svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M15.9346 -1.4727e-10C7.6503 0 0.93457 6.71573 0.93457 15C0.93457 23.2843 7.6503 30 15.9346 30C24.2188 30 30.9346 23.2843 30.9346 15C30.9346 6.71573 24.2188 -2.28604e-10 15.9346 -1.4727e-10ZM23.6851 11.9921L23.6851 11.5162C24.4227 10.9927 25.0414 10.3264 25.5173 9.56498C24.851 9.87432 24.1372 10.0647 23.3757 10.1599C24.1372 9.68396 24.732 8.9701 25.0176 8.08968C24.2799 8.518 23.4947 8.82733 22.6381 8.9939C21.9718 8.28004 20.9962 7.82794 19.9254 7.82794C17.8553 7.82794 16.1896 9.4936 16.1896 11.5638C16.1896 11.8493 16.2134 12.1587 16.2848 12.4204C13.1915 12.2538 10.4312 10.7785 8.59903 8.518C8.28969 9.06528 8.09933 9.70775 8.09933 10.3978C8.09933 11.7065 8.76559 12.8487 9.76498 13.515C9.14631 13.4912 8.57523 13.3246 8.07554 13.0391L8.07554 13.0867C8.07554 14.8951 9.36047 16.3942 11.0737 16.7273C10.7644 16.8225 10.4312 16.8701 10.0981 16.8701C9.83636 16.8701 9.62221 16.8463 9.38426 16.7987C9.83637 18.274 11.2165 19.3686 12.8583 19.3924C11.5734 20.3918 9.95534 20.9867 8.21831 20.9867C7.93277 20.9867 7.62343 20.9629 7.33789 20.9391C9.00354 21.986 10.9547 22.6047 13.0725 22.6047C19.9254 22.6047 23.6851 16.9177 23.6851 11.9921Z" fill="#9AA1B7"/>
                  </svg>
                </a>
              </li>
              <li onClick={() => socialIconClick('Facebook')}>
                <a
                  href={`https://www.facebook.com/LucaPlusAU/`}
                  target="_blank"
                  className="no-underline inline-flex items-center  px-1 py-2 text-gray-26 hover:text-brand rounded   font-bold md:ml-2 text-xl"
                >
                  <svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.5664 -1.47372e-10C7.27518 0 0.566406 6.70878 0.566406 15C0.566406 23.2912 7.27518 30 15.5664 30C23.8576 30 30.5664 23.2873 30.5664 15C30.5664 6.70878 23.8576 -2.28832e-10 15.5664 -1.47372e-10ZM19.5909 14.9219L16.9887 14.9219L16.9887 24.3149L13.1205 24.3149L13.1205 14.9219L11.1473 14.9219L11.1473 11.6866L13.1205 11.6866L13.1205 9.71347C13.1205 7.11123 14.2262 5.52878 17.3051 5.52878L19.9074 5.52878L19.9074 8.764L18.3288 8.764C17.1449 8.764 17.0668 9.23678 17.0668 10.026L17.0668 11.6046L19.9855 11.6046L19.5909 14.9219Z" fill="#9AA1B7"/>
                  </svg>
                </a>
              </li>
              <li onClick={() => socialIconClick('Youtube')}>
                <a
                  href="https://www.youtube.com/channel/UC0652wQaMNRp1c9_I4ZdoAA"
                  target="_blank"
                  className="no-underline inline-flex items-center  px-1 py-2 text-gray-26 hover:text-brand  rounded   font-bold md:ml-2 text-xl"
                >
                  <svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0)">
                      <path d="M13.6602 17.9736L18.8876 15L13.6602 12.0264L13.6602 17.9736Z" fill="#9AA1B7"/>
                      <path d="M15.7051 -1.4727e-10C7.4208 0 0.705078 6.71572 0.705078 15C0.705078 23.2843 7.4208 30 15.7051 30C23.9894 30 30.7051 23.2843 30.7051 15C30.7051 6.71572 23.9894 -2.28604e-10 15.7051 -1.4727e-10ZM25.2872 19.8451C25.1742 20.2707 24.9513 20.6591 24.641 20.9714C24.3306 21.2838 23.9437 21.5091 23.5188 21.6249C21.9594 22.0453 15.7051 22.0453 15.7051 22.0453C15.7051 22.0453 9.45078 22.0453 7.89131 21.6249C7.46648 21.5091 7.07952 21.2838 6.76917 20.9714C6.45882 20.6591 6.23598 20.2707 6.12295 19.8451C5.70518 18.2754 5.70518 15 5.70518 15C5.70518 15 5.70518 11.7246 6.12295 10.1549C6.23598 9.72932 6.45882 9.34091 6.76917 9.02856C7.07952 8.7162 7.46648 8.49086 7.89131 8.3751C9.45078 7.95469 15.7051 7.95469 15.7051 7.95469C15.7051 7.95469 21.9594 7.95469 23.5188 8.3751C23.9437 8.49086 24.3306 8.7162 24.641 9.02856C24.9513 9.34091 25.1742 9.72932 25.2872 10.1549C25.705 11.7246 25.705 15 25.705 15C25.705 15 25.705 18.2754 25.2872 19.8451Z" fill="#9AA1B7"/>
                    </g>
                    <defs>
                      <clipPath id="clip0">
                        <rect width="30" height="30" fill="white" transform="translate(0.705078)"/>
                      </clipPath>
                    </defs>
                  </svg>
                </a>
              </li>
            </ul>
          </span>
        </div>
      </div>
      <div className='text-brand text-15 flex container sm:py-8 sm:mb-0 mb-8 sm:mt-0 mt-3 flex-col sm:flex-row'>
        <div className='flex sm:ml-8 sm:px-0 px-3 flex-wrap'>
          <img src={mapPinImage} className='mr-2 sm:block hidden' />
          Suite 302, 432 St Kilda Rd, Melbourne VIC 3004
        </div>
        <div className='sm:ml-10 mt-3 sm:mt-0'>
          <a href="tel:+61 (03) 9005 5308">
            T: +61 (03) 9005 5308
          </a>
        </div>
        <div className='sm:ml-10 mt-3 sm:mt-0'>
          <a href="mailto:support@lucaplus.com">
            E: support@lucaplus.com
          </a>
        </div>
      </div>

      <div className='mt-8 mb-5 sm:hidden flex justify-content-center' onClick={backToTopClick}>
        <img src={backToTopImage} />
      </div>

      <div className="bg-brand relative z-30">
        <div className="mx-auto text-white text-xs leading-4 py-2 text">
          © Copyright 2025 LUCA Plus
        </div>
      </div>
      <Modali.Modal {...contactModal} hubspot={true}>
        <div className="hero-hubspot">
          <iframe
            src={`https://meetings.hubspot.com/ray-wang/meeting-with-luca-plus`}
            title="Introduction to LUCA Plus"
            frameBorder="0"
            webkitallowfullscreen="true"
            mozallowfullscreen="true"
            allowFullScreen
          />
        </div>
      </Modali.Modal>
    </section>
  )
}
